import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import EditableProMode from 'components/Editor/cource/layout/controls/ElementControls/EditableProMode'
import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import TableDemo from './TableDemo'
import TableElement from './TableElement'
import TableFormBrand from './TableFormBrand'
import { STYLE_FORM_SCHEMA } from './TableFormStyle'
import TableFormValue from './TableFormValue'
import tableIcon from './table.svg'

export default genElementConfig(CONFIG_ELEMENTS.table, {
  icon: tableIcon,
  label: t('elements.table.label'),
  group: ElementGroup.view,
  styleFields: STYLE_FORM_SCHEMA,
  Element: TableElement,
  Demo: TableDemo,
  FormValue: TableFormValue,
  FormBrand: TableFormBrand,
  EditorActions: EditableProMode,
})
